<div class="legal-entity-list-wrapper">
  <app-toolbar
    [statusDescriptions]="bcrStatuses"
    [currentStatusDescription]="selectedStatusDescription"
    [showStatusDropdown]="showStatusDropdown"
  />
  <section class="feature-shell">
    <div class="list-layout">
      <div class="list-panel overlay-scroll--custom" scrollActivity [scrollActivityCustom]="true">
        <div class="search-row">
          <app-az-searchbar
            [search]="true"
            [value]="searchText()"
            (valueChange)="onSearchChange($event)"
            [datePicker]="false"
          />
        </div>
        <!-- <div class="toggle-row historical-switch">
        <app-switch
          [checked]="historicalMode()"
          (changed)="historicalMode.set($event)"
          ariaLabel="Historical Search"
          label="HISTORICAL SEARCH"
          size="sm"
        ></app-switch>
      </div> -->
        <!-- Loader & error states -->
        @if (loadError()) {
          <div class="status-row" aria-live="polite">
            @if (loadError()) {
              <div class="error-container" role="alert">
                {{ loadError() }}
              </div>
            }
          </div>
        }
        @if (loading()) {
          <div class="loading-overlay" aria-live="polite" aria-label="Loading legal entities">
            <div class="overlay-content">
              <app-spinner [display]="true" [diameter]="48" aria-label="Loading"></app-spinner>
              <span>Loading legal entities…</span>
            </div>
          </div>
        }
        <div class="entity-groups">
          @for (group of displayGroups(); track trackByCountry($index, group)) {
            <app-accordion-panel
              [title]="group.country"
              [panelId]="'panel-' + group.country"
              [expanded]="isExpanded(group.country)"
              [items]="group.legal_entities"
              [activeId]="activeId()"
              (itemSelect)="select($event)"
              (panelToggled)="toggleCountry(group.country)"
            ></app-accordion-panel>
          }
        </div>
      </div>
      @if (activeId(); as selectedId) {
        <div
          class="detail-panel overlay-scroll--custom"
          scrollActivity
          [scrollActivityCustom]="true"
        >
          <app-legal-entity-detail [entityId]="selectedId" />
        </div>
      }
    </div>
  </section>
</div>
